import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

export const Spinner = () => {
  return <FontAwesomeIcon spin icon={faSpinner} size="2x" />;
};
